import { io, Socket } from 'socket.io-client';
import { tokenStorage } from './api';

const SOCKET_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3001/api').replace(/\/api$/, '');

let socket: Socket | null = null;

export function connectSocket(): Socket | null {
  const token = tokenStorage.getAccessToken();
  if (!token) return null;

  if (socket) {
    socket.disconnect();
  }

  socket = io(SOCKET_URL, {
    auth: { token },
    autoConnect: true
  });

  return socket;
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = null;
}

export function getSocket(): Socket | null {
  return socket;
}
